'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../utils/lib/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShareButton = function ShareButton(_ref) {
  var onClick = _ref.onClick,
      icon = _ref.icon,
      name = _ref.name;
  return _react2.default.createElement(
    'button',
    {
      className: 'ec-share-button ec-share-button--transparent ec-share-button--' + name.toLowerCase(),
      onClick: onClick
    },
    icon,
    _react2.default.createElement(
      'span',
      { className: 'ec-share-cta-text' },
      name
    )
  );
};

ShareButton.propTypes = {
  onClick: _PropTypes2.default.func.isRequired,
  icon: _PropTypes2.default.node.isRequired,
  name: _PropTypes2.default.string.isRequired
};

exports.default = ShareButton;